import React, { ReactNode, useState } from 'react'

import { Button, ErrorModal, Input, SectionSubtitle } from '../../../..'
import { useStudents, useUser } from '../../../../../context'
import { Spacer } from '../../../../global'

const LinksSection = () => {
  const { onEditionMode, setOnEditionMode } = useUser()
  const { activeStudent, saveStudent } = useStudents()

  const [saveMessage, setSaveMessage] = useState<string | null | ReactNode>(
    null,
  )
  const [openModal, setOpenModal] = useState(false)

  const [dropboxLink, setDropboxLink] = useState<string | undefined>(
    activeStudent?.dropboxLink,
  )

  const handleSave = async () => {
    try {
      activeStudent &&
        (await saveStudent(
          { ...activeStudent, dropboxLink: dropboxLink },
          activeStudent.uid,
        ))
      setSaveMessage('Link actualizado con exito')
    } catch (error) {
      setSaveMessage('Hubo un error, por favor intentalo de nuevo más tarde.')
    }
    setOpenModal(true)
    setOnEditionMode(false)
  }

  return (
    <>
      {saveMessage && openModal && (
        <ErrorModal
          setOpenModal={setOpenModal}
          errorMessage={saveMessage}
          setError={setSaveMessage}
        />
      )}
      <SectionSubtitle
        children="Links del alumno"
        fontSize={18}
        fontWeight={500}
      />
      <Spacer height={30} />
      <SectionSubtitle
        children="Link de Dropbox:"
        fontSize={14}
        fontWeight={500}
      />
      <Spacer height={20} />
      <Input
        name="dropboxLink"
        id="dropboxLink"
        defaultValue={activeStudent?.dropboxLink}
        width="400px"
        disabled={!onEditionMode}
        onChange={(e) => setDropboxLink(e.target.value)}
      />
      <Spacer height={20} />
      {onEditionMode ? (
        <Button label="Guardar" onClick={handleSave} className="dark-grey" />
      ) : (
        <Button
          label={
            activeStudent?.dropboxLink
              ? 'Cambiar el link'
              : 'Agregar link a Dropbox'
          }
          onClick={() => setOnEditionMode(true)}
          className="dark-grey"
        />
      )}
    </>
  )
}

export default LinksSection
